/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popStake.vue?vue&type=template&id=abbee30c"
import script from "./popStake.vue?vue&type=script&lang=js"
export * from "./popStake.vue?vue&type=script&lang=js"
import style0 from "./popStake.vue?vue&type=style&index=0&id=abbee30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports